import * as React from 'react';
import { st, classes } from './Toast.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { CloseIconButton } from './CloseIconButton';
export class Toast extends React.Component {
    constructor() {
        super(...arguments);
        this.handleOnCloseClick = (event) => {
            const { onClose } = this.props;
            onClose && onClose(event);
        };
    }
    render() {
        const { skin, shouldShowCloseButton, children, shouldAnimate, isShown, placement, className, } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile, rtl }) => (React.createElement("div", { className: st(classes.root, { mobile, skin, shouldAnimate, isShown, placement, rtl }, className), role: "alert", "data-is-shown": isShown, "data-skin": skin, "data-mobile": mobile, "data-hook": this.props['data-hook'] },
            React.createElement("span", { role: "presentation", className: classes.gapBeforeMessage }),
            React.createElement("span", { className: classes.message, "data-hook": "message" }, children),
            shouldShowCloseButton ? (React.createElement("div", { className: classes.closeButtonWrapper },
                React.createElement(CloseIconButton, { onClick: this.handleOnCloseClick, "data-hook": "closeButton" }))) : (React.createElement("span", { role: "presentation", className: classes.gapAfterMessage }))))));
    }
}
Toast.displayName = 'Toast';
Toast.defaultProps = {
    shouldShowCloseButton: false,
    isShown: true,
};
//# sourceMappingURL=Toast.js.map